export enum ePolicyContextActionType {
  OpenEditSingleFieldAction = 'Policy Context Action - Open Edit Single Field Action',
  CloseEditSingleFieldAction = 'Policy Context Action - Close Edit Single Field Action',
  SetOrder = 'Policy Context Action - Set Order',
}
